import type { SelectChangeEvent } from '@mui/material';
import { InputLabel, MenuItem, Select } from '@mui/material';
import type { FormEvent } from 'react';
import { useCallback } from 'react';
import type { MissionFilterOptions } from '../../../assets/constants/missionFiltering';
import { COPY } from '../../../assets/copy/copy';
import { CaretIcon } from '../../../assets/svgs';

type FiltersAsDropDownProps = {
  onFormSubmit: (e: FormEvent<HTMLFormElement>) => void;
  selectedCategory: string | undefined;
  categories: MissionFilterOptions;
  handleCategoryChange: (category: string) => void;
};

export function FiltersAsDropDown(props: FiltersAsDropDownProps): JSX.Element {
  const { onFormSubmit, selectedCategory, categories, handleCategoryChange } =
    props;

  const onCategoryChange = useCallback(
    (e: SelectChangeEvent<string>) => {
      handleCategoryChange(e.target.value);
    },
    [handleCategoryChange]
  );

  return (
    <form onSubmit={onFormSubmit}>
      <div>
        <div className="label-wrapper">
          <InputLabel className="small-text grey" id="mission-categories">
            {COPY.MISSIONS.MISSION_ACTIONS.CATEGORY}
          </InputLabel>
        </div>
        <Select
          IconComponent={CaretIcon}
          value={selectedCategory ?? 'All'}
          onChange={onCategoryChange}
          id="mission-categories"
          label="Category"
          className="bold selector"
        >
          {categories.map((catProp) => (
            <MenuItem
              className={`bold mission-filtering-item ${
                catProp.className ?? ''
              }`}
              key={catProp.displayValue}
              value={catProp.displayValue}
            >
              {catProp.displayValue}
            </MenuItem>
          ))}
        </Select>
      </div>
    </form>
  );
}
